// extracted by mini-css-extract-plugin
export default {"resetPassword":"resetPassword-module--resetPassword--b55be"};